(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    function scrollToReviewsSection() {
    const reviewsSection =
      document.querySelector('#product-reviews') ||
      document.querySelector('#reviews') ||
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('#looxReviews') ||
      document.querySelector('#shopify-product-reviews') ||
      document.querySelector('[data-product-reviews]');

    if (!reviewsSection) return;

    reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-scroll-to-reviews]');
    if (!trigger) return;
    scrollToReviewsSection();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-scroll-to-reviews]');
    if (!trigger) return;
    event.preventDefault();
    scrollToReviewsSection();
  });
  } catch(e) { console.error(e); }
})();

})();
